// Closed-beta signup gate — GET /api/v1/auth/signup-policy (public,
// unauthenticated). When the backend's SIGNUP_ACCESS_CODE env is set,
// registration requires a matching access code and the create-account
// form must show the field.
//
// Fail-open on fetch errors: an unreachable policy endpoint must not
// block open signup. If the gate IS active, the register call still
// 403s with "invalid_access_code" and the form reveals the field then.

import { useQuery } from "@tanstack/react-query";

import { attachRequestIdToScope } from "../../lib/api-client";

export type SignupPolicy = {
  access_code_required: boolean;
};

async function fetchSignupPolicy(): Promise<SignupPolicy> {
  const response = await fetch("/api/v1/auth/signup-policy", {
    credentials: "include",
  });
  attachRequestIdToScope(response);
  if (!response.ok) {
    throw new Error(`signup policy fetch failed: ${response.status}`);
  }
  return (await response.json()) as SignupPolicy;
}

export function useSignupPolicy() {
  return useQuery({
    queryKey: ["signup-policy"],
    queryFn: fetchSignupPolicy,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
